import {type Module} from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// state
const state: TelephoneToolbarState = {
    initialized: false,
    lastUpdate: 0,
    settings: {
        onlyEntity: false,
        showNotifications: false,
    },
    employees: {},
    openRequestCount: 0,
    open: false,
};

// module
const telephoneToolbar: Module<TelephoneToolbarState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

export default telephoneToolbar;